import { BoxProps, Spinner } from '@chakra-ui/react';
import { Text, Colors } from '@mercator-gcp/grout';
import { CompanyChip } from 'components/elements/Chips/CompanyChip';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import { useCompanyInvolvement } from 'hooks/useCompanies';
import { formatInteger } from 'utils/format';

const containerStyle = {
  background: Colors.ArmyGreen200,
  display: 'flex',
  flexDirection: 'column',
  minHeight: '200px',
  paddingTop: 'padding_16',
  borderRadius: '4px',
};

const labelStyle = {
  color: Colors.TextQuiet,
  paddingBottom: 'padding_8',
  paddingX: 'padding_16',
};

const loadingStyle = {
  padding: 'padding_16',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50%',
};

const involvedCompaniesListStyle = {
  overflowY: 'auto',
  rowGap: 'padding_4',
  paddingX: 'padding_16',
  paddingBottom: 'padding_16',
};

const Content = ({ id }: Props) => {
  const { data: involvedCompanies, isLoading } = useCompanyInvolvement(id);

  if (isLoading) {
    return (
      <FlexColumn sx={loadingStyle}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="brand.army-green"
          size="xl"
        />
      </FlexColumn>
    );
  }

  if (involvedCompanies?.length) {
    return (
      <FlexColumn sx={involvedCompaniesListStyle}>
        {involvedCompanies?.map((involvedCompany: any) => (
          <FlexRow
            key={`involved-company-${involvedCompany.uuid}-${involvedCompany.name}`}
          >
            <CompanyChip
              id={involvedCompany.uuid}
              name={involvedCompany.name}
              maxWidth="calc(100% - 24px)"
            />
            <Text>{formatInteger(involvedCompany.count)}</Text>
          </FlexRow>
        ))}
      </FlexColumn>
    );
  }

  return (
    <FlexColumn sx={involvedCompaniesListStyle}>
      <Text>No companies found.</Text>
    </FlexColumn>
  );
};

type Props = {
  id: string;
} & BoxProps;

const CommonlyWorksWith = ({ sx = {}, ...props }: Props) => {
  const mainStyle = { ...containerStyle, ...sx };

  return (
    <FlexColumn sx={mainStyle}>
      <Text.SmallLabel sx={labelStyle}>Commonly works with</Text.SmallLabel>
      <Content id={props.id} />
    </FlexColumn>
  );
};

export default CommonlyWorksWith;
